import React from "react";
import { ComponentProps, ComponentWidth } from "../../../types";
import { SectionWrapper } from "../../containers/SectionWrapper";
import {
  SummaryPod,
  SummaryPodProps,
} from "../../elements/SummaryPod/SummaryPod";
import * as styles from "./StackedDisplay.module.css";

interface Props extends ComponentProps, ComponentWidth {
  heading: string;
  summaries: SummaryPodProps[];
}

export const StackedDisplay: React.FC<Props> = ({
  summaries,
  heading,
  width,
  ...props
}) => {
  const classes = [styles.stackeddisplay];
  width === "contained" && classes.push(styles.contained);

  const renderSummaries = () =>
    summaries.map((summary, idx) => (
      <SummaryPod
        {...summary}
        className={styles.summary}
        key={`summary${idx}`}
        squareImage={false}
      />
    ));

  return (
    <SectionWrapper {...props}>
      <div className={classes.join(" ")}>
        {heading && (
          <div className={styles.heading}>
            <h2>{heading}</h2>
          </div>
        )}
        <div className={styles.summaries}>{renderSummaries()}</div>
      </div>
    </SectionWrapper>
  );
};
